import { useMemo, useState } from "react";
import { fetch } from "./fetch";

export type FetchControls = {
  fetch: typeof fetch;
  abort: () => void;
  isFetching: boolean;
};

/**
 * Wrapped fetch, with abort controller, and isFetching state
 * @returns
 */
export function useFetch(): FetchControls {
  const [isFetching, setIsFetching] = useState(false);
  const abortController = new AbortController();

  let abort = () => abortController.abort();

  const wrappedFetch = async <T>(...args: Parameters<typeof fetch<T>>) => {
    const [url, method, body, port] = args;
    setIsFetching(true);
    try {
      const result = await fetch<T>(url, method, body, abortController.signal, port);
      return result;
    } finally {
      setIsFetching(false);
    }
  };

  return useMemo(
    () => ({
      fetch: wrappedFetch,
      abort,
      isFetching,
    }),
    [setIsFetching, isFetching],
  );
}
